import {
  CouponCopyEventType,
  couponGenerationEventType,
  CouponVisitEventType,
  DashboardVisitEventType,
  GenerateCouponEventType,
  LandingPageEventType,
  LoginVisitEventType,
  OtpPageClickEventType,
  PageVisitEventType,
  PaymentUpdateEventType,
  ProgramDetailEventType,
  ProgramSelectEventType,
  SignInSuccessEventType,
  SignUpSuccessEventType,
} from '@utils/types'
import { EventType } from '../events'
import { EVENT_PLATFORMS } from '@pw-tech/web-sdk'

const eventTracker = {
  ambs_landing_page: (gaEventPayload: LandingPageEventType) => {
    // logEvent(EventType.AMBS_LANDING_PAGE, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_LANDING_PAGE,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_login_visit: (gaEventPayload: LoginVisitEventType) => {
    // logEvent(EventType.AMBS_LOGIN_VISIT, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_LOGIN_VISIT,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_otp_page_visit: () => {
    // logEvent(EventType.AMBS_OTP_PAGE_VISIT, {})
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_OTP_PAGE_VISIT,
      eventData: {},
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_signin_success: (gaEventPayload: SignInSuccessEventType) => {
    // logEvent(EventType.AMBS_SIGNIN_SUCCESS, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_SIGNIN_SUCCESS,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_otp_page_click: (gaEventPayload: OtpPageClickEventType) => {
    // logEvent(EventType.AMBS_OTP_PAGE_CLICK, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_OTP_PAGE_CLICK,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_personal_details_visit: (gaEventPayload: { user_type: string }) => {
    // logEvent(EventType.AMBS_PERSONAL_DETAILS_VISIT, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_PERSONAL_DETAILS_VISIT,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_program_select_visit: (gaEventPayload: ProgramSelectEventType) => {
    // logEvent(EventType.AMBS_PROGRAM_SELECT_VISIT, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_PROGRAM_SELECT_VISIT,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_program_detail_visit: (gaEventPayload: ProgramDetailEventType) => {
    // logEvent(EventType.AMBS_PROGRAM_DETAIL_VISIT, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_PROGRAM_DETAIL_VISIT,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_signup_success: (gaEventPayload: SignUpSuccessEventType) => {
    // logEvent(EventType.AMBS_SIGNUP_SUCCESS, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_SIGNUP_SUCCESS,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_dashboard_visit: (gaEventPayload: DashboardVisitEventType) => {
    // logEvent(EventType.AMBS_DASHBOARD_VISIT, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_DASHBOARD_VISIT,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_payment_update_click: (gaEventPayload: PaymentUpdateEventType) => {
    // logEvent(EventType.AMBS_PAYMENT_UPDATE_CLICK, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_PAYMENT_UPDATE_CLICK,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_payment_update_success: (gaEventPayload: PaymentUpdateEventType) => {
    // logEvent(EventType.AMBS_PAYMENT_UPDATE_SUCCESS, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_PAYMENT_UPDATE_SUCCESS,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_coupon_code_visit: (gaEventPayload: CouponVisitEventType) => {
    // logEvent(EventType.AMBS_COUPON_CODE_VISIT, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_COUPON_CODE_VISIT,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  generate_coupon_click: (gaEventPayload: GenerateCouponEventType) => {
    // logEvent(EventType.GENERATE_COUPON_CLICK, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.GENERATE_COUPON_CLICK,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },

  ambs_coupon_code_copy: (gaEventPayload: CouponCopyEventType) => {
    // logEvent(EventType.AMBS_COUPON_CODE_COPY, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.GENERATE_COUPON_CLICK,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_earning_level_visit: (gaEventPayload: PageVisitEventType) => {
    // logEvent(EventType.AMBS_EARNING_LEVELS_VISIT, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_EARNING_LEVELS_VISIT,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_performance_report_visit: (gaEventPayload: PageVisitEventType) => {
    // logEvent(EventType.AMBS_PERFORMANCE_REPORT_VISIT, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_PERFORMANCE_REPORT_VISIT,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_resource_center_visit: (gaEventPayload: PageVisitEventType) => {
    // logEvent(EventType.AMBS_RESOURCE_CENTER_VISIT, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_RESOURCE_CENTER_VISIT,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_contact_us_click: (gaEventPayload: PageVisitEventType) => {
    // logEvent(EventType.AMBS_CONTACT_US_CLICK, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_CONTACT_US_CLICK,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_payment_page_visit: (gaEventPayload: PageVisitEventType) => {
    // logEvent(EventType.AMBS_PAYMENT_PAGE_VISIT, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_PAYMENT_PAGE_VISIT,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_logout_click: (gaEventPayload: PageVisitEventType) => {
    // logEvent(EventType.AMBS_LOGOUT_CLICK, gaEventPayload)
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_LOGOUT_CLICK,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
  ambs_coupon_generation: (gaEventPayload: couponGenerationEventType) => {
    window?.PWWebSDK?.eventService?.logEvent({
      eventName: EventType.AMBS_COUPON_GENERATION,
      eventData: gaEventPayload,
      logTo: [EVENT_PLATFORMS.GA],
    })
  },
}

export default eventTracker
